import type { ReactNode } from "react";

import styles from "./Kbd.module.css";
import { cx } from "../lib/cx";

export type KbdProps = {
  readonly children: ReactNode;
  readonly className?: string;
  /** Cut from a dark surface rather than laid on a light one. */
  readonly inverse?: boolean;
};

export const Kbd = ({ children, className, inverse }: KbdProps) => (
  <span className={cx(styles.kbd, inverse && styles.inverse, className)}>
    {children}
  </span>
);
